import apiClient from '../axios.js';

export const quoteEstimateService = {
  list(params = {}) {
    return apiClient.get('/system/quote-estimates', { params });
  },

  get(id, version) {
    const params = version ? { version } : {};
    return apiClient.get(`/system/quote-estimates/${id}`, { params });
  },

  create(payload) {
    return apiClient.post('/system/quote-estimates', payload);
  },

  createVersion(id, payload) {
    return apiClient.post(`/system/quote-estimates/${id}/versions`, payload);
  },

  markWon(id, { invoiceParty, versionNo }) {
    return apiClient.post(`/system/quote-estimates/${id}/won`, { invoiceParty, versionNo });
  },

  remove(id) {
    return apiClient.delete(`/system/quote-estimates/${id}`);
  }
};
